import { render } from "./SegurosRegistro.vue?vue&type=template&id=5fc3da6b"
import script from "./SegurosRegistro.vue?vue&type=script&lang=js"
export * from "./SegurosRegistro.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__